package com.milta.core.localization.translations.de

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Ein Fehler ist aufgetreten",
    error = "Fehler",
    fieldRequired = "Dieses Feld ist erforderlich",
    invalidEmail = "Ungültige E-Mail-Adresse",
    fileTooLarge = "Datei zu groß. Wählen Sie eine kleinere Datei.",
)
